<template>
  <div class="bootstrap-tagsinput">
    <el-tag
      v-for="(tag, index) in dynamicTags"
      :key="tag.label + index"
      size="small"
      :type="tagType"
      :closable="tag.removable"
      :close-transition="false"
      @close="handleClose(tag)"
    >
      {{ tag.label }}
    </el-tag>

    <input
      class="form-control"
      v-model="inputValue"
      ref="saveTagInput"
      size="mini"
      v-bind="$attrs"
      @input="onInput"
      @keyup.enter="handleInputConfirm($event)"
      v-on:keydown.enter.prevent="prevenirEnter($event)"
      @blur="handleInputConfirm"
    />
  </div>
</template>

<script>
import { Tag } from 'element-ui';
/**
 * Nota por Alejandro:
 * 
 * Modifique este componente para que solo se pudiera cargar una lista de objetos con los atributos:
 * {
 *   label: "el texto del tag",
 *   removable: true o false, si se puede eliminar o no
 * }
 */
export default {
  name: 'tags-input',
  inheritAttrs: false,
  components: {
    [Tag.name]: Tag
  },
  props: {
    value: {
      type: Array,
      default: () => [],
      description: 'List of tags'
    },
    tagType: {
      type: String,
      default: 'primary',
      description: 'Tag type (primary|danger etc)'
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  data() {
    return {
      dynamicTags: [],
      inputVisible: false,
      inputValue: ''
    };
  },
  methods: {
    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
      this.$emit('change', this.dynamicTags);
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick(() => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm(evt) {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.dynamicTags.push({ label: inputValue, value: 0, removable: true});
        this.$emit('change', this.dynamicTags);
      }
      this.inputVisible = false;
      this.inputValue = '';
      
    },
    prevenirEnter(evt){
      return false;
    },
    onInput(evt) {
      this.$emit('input', evt.target.value);
    }
  },
  created() {
    this.$watch(
      'value',
      newVal => {
        this.dynamicTags = [...newVal];
      },
      { immediate: true }
    );
  }
};
</script>
